import { FC } from 'react'

import styled from 'styled-components'

import { FullScreenModal } from 'src/Components/FullScreenModal'
import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'

import { AdsPlacementsModalContent } from './AdsPlacementsModalContent'

const Container = styled.div`
  display: flex;
  padding: 24px 16px 80px 16px;
  flex-direction: column;
  gap: 24px;
  position: relative;

  & > *:first-child + * {
    margin-top: 0;
    margin-bottom: 0;
  }

  @media screen and (min-width: ${MAX_MOBILE_WIDTH}) {
    margin: 0 auto;
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 64px;
    width: 600px;
  }
`

export const AdsPlacementsModal: FC = () => {
  const { setSearch } = useCustomSearchParams()

  return (
    <FullScreenModal
      showCloseButton
      fixedCloseButton={false}
      open
      closable
      prefixCls='visual'
      onCancel={() => setSearch({ modal: null })}
    >
      <Container>
        <AdsPlacementsModalContent />
      </Container>
    </FullScreenModal>
  )
}
